{
  "dashboard": {
    "column": {
      "title": "Title",
      "todo": "To do"
    },
    "header": "Dashboard",
    "myTodos": {
      "title": "My todos",
      "itemsCount": "{{count}} todos",
      "empty": "No todos at the moment",
      "tooltips": {
        "reviewStep": "You have a document to review",
        "approveStep": "A document requires your approval",
        "publishDocument": "Workflow complete, ready to publish",
        "rejectedStepByUser": "{{name}} rejected a workflow step",
        "rejectedStepByYou": "You rejected a workflow step",
        "rejectedStepFallback": "A workflow step was rejected",
        "moveForward": "Step complete, next step can be activated",
        "readDocument": "You have a document to read"
      },
      "dateLabels": {
        "published": "Published",
        "adopted": "Adopted",
        "date": "Date",
        "stepDueAt": "Step response date",
        "documentVersionReviewTo": "Scheduled end date"
      }
    },
    "ongoing": {
      "workflows": "Ongoing Workflows"
    },
    "publish": {
      "title": "Document Acceptance Status"
    },
    "upcoming": {
      "workflows": "Upcoming Workflows"
    },
    "createDocument": {
      "uploadFile": "Upload file",
      "file": "File",
      "fileType": "Type",
      "fileTypeDescription": "Please note that editing Office documents requires an active Microsoft 365 license",
      "supportedFormats": "Supported file formats:",
      "errorCreating": "Error creating document"
    },
    "userManual": {
      "getStarted": "Get started with North House by reading the",
      "userGuide": "User guide"
    }
  }
}
